export default __webpack_public_path__ + "static/media/screenBlock12.01293dd0.jpg";